var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"vs-bg",attrs:{"fill-height":""}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('app-content'),_vm._v(" "),_c('connection-checker'),_vm._v(" "),_c('service-worker')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }